import * as React from 'react';

import { BtiCommercialFooterContainer } from '../bti_commercial_footer/container';

import * as styles from './index.css';

export class BtiCommercialContainer extends React.Component<{}, {}> {
  public render() {
    return (
      <div className={styles['container']}>
        {this.props.children}
        {<BtiCommercialFooterContainer />}
      </div>
    );
  }
}
